import CarouselComponent from './Carousel';
import Buttons from './CarouselButtons';

const Carousel = {
  Carousel: CarouselComponent,
  Buttons
};

export default Carousel;
